import { Typography } from "@mui/material";
import { DownloadLink, Text } from "./styles";
import { SVSOURCE_CONTACT } from "utils/constants";
import { ADDITIONAL_VENTURE_LINK } from "constants/global";

export const cliniciansContent = {
  documentTitle: 'Single Ventricle SOURCE',
  pageTitle: 'For Clinicians',
  footnote: (
    <>
        We would love to discuss bringing your clinic into the SOURCE study!  Please reach out to us at&nbsp;
        <DownloadLink
          to="#"
          onClick={(e) => {
            e.preventDefault(); // prevent navigation
            window.location.href = `mailto:${SVSOURCE_CONTACT.EMAIL}`;
          }}
        >
          {SVSOURCE_CONTACT.EMAIL}
        </DownloadLink>
      <br />
      <br />
      If you’re a researcher and you’d like to learn more about the study
      and its data, please visit the{' '}
      <a href={ADDITIONAL_VENTURE_LINK}>Additional Ventures</a> website.
    </>
  ),
  helpDescription: {
      subTitle: (
        <>
          Please help us spread the word about SOURCE{' '}
          <Typography variant='pl1'>
              by sharing information about this study with your single ventricle patients and families!
          </Typography>
        </>
        ),
      description: `We need your help to make SOURCE the largest and most extensive genetic and clinical dataset focused exclusively on single ventricle heart disease. The de-identified data will be available to all qualified researchers at no cost, fueling many studies for years to come to advance the field and accelerate improvements in outcomes and care for patients.`
    },
    getAccessDescription: {
      subTitle: 'Here’s how you and your institution can work with SOURCE:',
      list: ['Become an in-clinic enrollment site. We provide funding for recruiters and administrative time to facilitate enrollment in SOURCE at your clinic.',
        'Share your de-identified single ventricle genetic samples with SOURCE. We are partnering with institutions to sequence their deidentified samples, return the data back to the institution, and ingest the de-identified data into SOURCE.',
        'Share flyers, brochures, and study information with single ventricle patients and families in your clinic and/or through the patient portal.'
      ],
        downloadBrochure: (
          <>
            <Text>
              Download the{' '}
              <DownloadLink to='/pdf/source_brochure.pdf' target='_blank'>
                SOURCE Brochure
              </DownloadLink>{' '}
              and{' '}
              <DownloadLink to='/pdf/source_onepager.pdf' target='_blank'>
                SOURCE One-Pager
              </DownloadLink>
            </Text>
          </>
        )
    }
};